import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.99 13.436 8.815 9.261a3.664 3.664 0 0 1-1.15.66 3.844 3.844 0 0 1-1.306.233c-1.068 0-1.971-.37-2.711-1.109-.74-.739-1.11-1.642-1.11-2.71 0-1.067.37-1.971 1.109-2.711.738-.74 1.641-1.11 2.709-1.111 1.068-.001 1.972.369 2.712 1.109.74.74 1.11 1.644 1.11 2.711 0 .463-.081.912-.245 1.345a3.65 3.65 0 0 1-.647 1.112l4.175 4.174-.471.472Zm-6.63-3.95c.884 0 1.63-.304 2.24-.913.608-.609.913-1.355.913-2.24 0-.885-.305-1.632-.914-2.24-.609-.609-1.355-.913-2.24-.914-.884 0-1.631.304-2.24.914-.61.609-.914 1.356-.914 2.24 0 .884.305 1.63.914 2.24.608.609 1.355.913 2.24.913",
  fill: "#000"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }